import { defaultHeaders } from './common';

export const getTaxConf = (facilityId: number | string) => {
  return {
    method: 'get',
    url: '/api/facility/' + facilityId + '/tax',
    headers: defaultHeaders,
  };
};
